<template>
  <div class="filters" :class="{ 'expand': show }">
    <div class="innerfilters">
      <transition name="fade" mode="out-in">
        <div v-if="!addressReady && !showExtensions" class="panel postalpanel">
          <postal-box :loading="loading" :location="location" @postal="$emit('postal', $event)" />
        </div>
      </transition>
      <!-- Adres -->
      <div v-if="!showExtensions && addressReady" class="panel" v-auto-animate>

        <div v-if="addressDisplayReady">
          <div class="header address">
            {{ location.display }}
          </div>
          <button class="link-element icon-right no-border-bottom" @click="$emit('editAddress')">
            <span>Wijzig</span>
            <icon icon="x-fa-edit" size="m" />
          </button>
        </div>
        <div v-else-if="loading">
          <div class="header address">We halen de adresgegevens op...</div>
        </div>
      </div>

      <!-- Filters -->
      <div class="panel">
        <div class="filter-field title-box">
          <span class="header">Filters</span>
        </div>
        <!-- Downloadsnelheid -->
        <div class="filter-field">
          <speed-slider v-model:speed="localFilters.minSpeed" label="Downloadsnelheid" :max-speed="maxSpeed" />
          <modal-hook name="speed-assistant">
            <template #content>
              <div class="link-element icon-right border-bottom">
                Welke snelheid heb ik nodig
                <icon icon="x-fa-info-circle" />
              </div>
            </template>
          </modal-hook>
        </div>

        <!-- Jouw verbinding -->
        <div class="">

          <FieldLabel label="Jouw verbinding" id="contract-types">
          </FieldLabel>

          <span class="subtle-text">Beschikbaar op jouw adres</span>
          <div class="checkbox-list">
            <CheckboxInput id="hasDsl" v-model="localFilters.dsl" :disabled="!hasDsl" name="hasDsl">
              {{ dslLabel }}
            </CheckboxInput>
            <CheckboxInput id="hasCable" v-model="localFilters.cable" :disabled="!hasCable" name="hasCable">
              {{ cableLabel }}
            </CheckboxInput>
            <CheckboxInput id="hasFiber" v-model="localFilters.fiber" :disabled="!hasFiber" name="hasFiber">
              {{ fiberLabel }}
            </CheckboxInput>
          </div>
        </div>
      </div>
      <!-- Contractduur Radio -->
      <div class="panel small">
        <FieldLabel label="Contractduur" />
          <div class="radio-group">
          <RadioInput
            v-for="duration in contractDurations"
            :key="duration.value"
            v-model="localFilters.contractDuration"
            :value="duration.value"
            type="alt"
            :title="duration.label"
            :id="`contract-duration-radio-${duration.value}`"
            name="contract-duration-radio"
          />
        </div>
      </div>
      <!-- Kies providers -->
      <div class="panel small">
        <div class="panel-filter-header">
          <span class="title">Kies providers</span>
          <modal-center name="provider-modal" class="filter-modal">
            <template #hook>
              <span>wijzig</span>
              <icon icon="x-fa-edit" size="sm" />
            </template>
            <template #content>
              <div class="modal-header">
                <div class="modal-title">
                  Providers
                </div>
                <div class="modal-intro">
                  Kies uit onderstaande providers om te filteren op providers
                </div>
              </div>

              <div class="checkbox-list">
                <CheckboxInput v-for="provider in providerList" v-bind="provider" :id="`provider-${provider.value}`"
                  v-model="localFilters.providers" :value="provider.value" name="active-providers">
                  {{ provider.label }}
                </CheckboxInput>
              </div>
              <div class="modal-footer">
                <span class="subtle-text">
                  Actieve filters:<br>
                  {{ providerText }}
                </span>
                <modal-hook name="provider-modal" class="footer-button">
                  <template #content>
                    <button-icon-right type="cta" label="Verder met vergelijken" />
                  </template>
                </modal-hook>
              </div>
            </template>
          </modal-center>
        </div>
        <span class="subtle-text">
          {{ providerText }}
        </span>
      </div>
      <!-- Combivoordeel -->
      <div class="panel small">
        <div class="panel-filter-header">
          <span class="title">Combivoordeel</span>
          <modal-center name="combivoordeel-modal" class="filter-modal">
            <template #hook>
              <span>wijzig</span>
              <icon icon="x-fa-edit" size="sm" />
            </template>
            <template #content>
              <div class="modal-header">
                <div class="modal-title">
                  Combivoordeel
                </div>
                <div class="modal-intro">
                  Vul je energieleverancier en mobiele provider in om te zien of je kan
                  profiteren van combivoordeel
                </div>
              </div>

              <div class="combi-discount-row ">
                <div class="checkbox-list">
                  <CheckboxInput v-for="provider in combiProvidersMobile" :id="`mobile-${provider.slug}`"
                    :key="provider.slug" v-model="localFilters.combiProviders" :value="provider.slug"
                    name="combi-providers">
                    {{ provider.label }}
                  </CheckboxInput>
                </div>
              </div>

              <div class="modal-footer">
                <span class="subtle-text">
                  Actieve filters:<br>
                  {{ combiProviderText }}
                </span>
                <modal-hook name="combivoordeel-modal" class="footer-button">
                  <template #content>
                    <button-icon-right type="cta" label="Verder met vergelijken" />
                  </template>
                </modal-hook>
              </div>
            </template>
          </modal-center>
        </div>
        <span class="subtle-text">
          {{ combiProviderText }}
        </span>
      </div>
      <!-- Tv-opties -->
      <div v-if="tvEnabled" class="panel small">
        <div class="panel-filter-header">
          <span class="title">Tv-opties</span>
          <modal-center name="tv-options-modal" class="filter-modal">
            <template #hook>
              <span>wijzig</span>
              <icon icon="x-fa-edit" size="sm" />
            </template>
            <template #content>
              <div class="modal-header">
                <div class="modal-title">
                  Tv opties
                </div>
              </div>

              <div class="checkbox-list">
                <CheckboxInput id="tv-extra-receiver" v-model="localFilters.tvExtraReceiver" name="tv-extra-receiver">
                  Extra ontvanger
                </CheckboxInput>
                <CheckboxInput id="tv-recording" v-model="localFilters.tvRecording" name="tv-recording">
                  TV opnemen
                </CheckboxInput>
                <CheckboxInput id="tv-rewind" v-model="localFilters.tvRewind" name="tv-rewind">
                  Live terugkijken
                </CheckboxInput>
                <CheckboxInput id="tv-app" v-model="localFilters.tvApp" name="tv-app">
                  Kijken via app
                </CheckboxInput>
              </div>

              <div class="modal-footer">
                <span class="subtle-text">
                  Actieve filters:<br>
                  {{ tvExtraText }}
                </span>
                <modal-hook name="tv-options-modal" class="footer-button">
                  <template #content>
                    <button-icon-right type="cta" label="Verder met vergelijken" />
                  </template>
                </modal-hook>
              </div>
            </template>
          </modal-center>
        </div>

        <span class="subtle-text">
          {{ tvExtraText }}
        </span>
      </div>
      <!-- Extra tv-zenders -->
      <div v-if="tvEnabled" class="panel small">
        <div class="panel-filter-header">
          <span class="title">Extra tv-zenders</span>
          <modal-center name="extra-tv-channels-modal" class="filter-modal">
            <template #hook>
              <span>wijzig</span>
              <icon icon="x-fa-edit" size="sm" />
            </template>
            <template #content>
              <div class="modal-header">
                <div class="modal-title">
                  Extra tv-zenders
                </div>
                <div class="modal-intro">
                  Selecteer extra zenders die je wilt hebben inbegrepen bij je abonnement. Je
                  hoeft geen standaard zenders zoals NPO 1, RTL of SBS 6 te selecteren.
                </div>
              </div>

              <tv-channel-selection v-model:tvChannels="localFilters.tvChannels" @updateLabel="setLabels" />

              <div class="modal-footer">
                <span class="subtle-text">
                  Actieve filters:<br>
                  {{ tvChannelLabel }}
                </span>
                <modal-hook name="extra-tv-channels-modal" class="footer-button">
                  <template #content>
                    <button-icon-right type="cta" label="Verder met vergelijken" />
                  </template>
                </modal-hook>
              </div>
            </template>
          </modal-center>
        </div>
        <span class="subtle-text">
          {{ tvChannelLabel }}
        </span>
      </div>
      <!-- Bellen -->
      <div v-if="phoneEnabled" class="panel small">
        <div class="panel-filter-header">
          <span class="title">Bellen</span>
          <modal-center name="phone-modal" class="filter-modal">
            <template #hook>
              <span>wijzig</span>
              <icon icon="x-fa-edit" size="sm" />
            </template>
            <template #content>
              <div class="modal-header">
                <div class="modal-title">
                  Extra opties voor Bellen
                </div>
                <div class="modal-intro">
                  Selecteer extra opties voor je vaste telefoon
                </div>
              </div>

              <div class="checkbox-list">
                <CheckboxInput id="numberRetention" v-model="localFilters.numberRetention" name="numberRetention">
                  Nummerbehoud
                </CheckboxInput>
                <CheckboxInput id="phone-unlimited-nl" v-model="localFilters.phoneUnlimitedNL"
                  name="phone-unlimited-nl">
                  Onbeperkt bellen Nederland
                </CheckboxInput>
                <CheckboxInput id="phone-unlimited-eu" v-model="localFilters.phoneUnlimitedEU"
                  name="phone-unlimited-eu">
                  Onbeperkt bellen EU-nummers
                </CheckboxInput>
                <CheckboxInput id="phone-unlimited-world" v-model="localFilters.phoneUnlimitedWorld"
                  name="phone-unlimited-world">
                  Wereldwijd onbeperkt bellen
                </CheckboxInput>
              </div>

              <div class="modal-footer">
                <span class="subtle-text">
                  Actieve filters:<br>
                  {{ phoneExtraText }}
                </span>
                <modal-hook name="phone-modal" class="footer-button">
                  <template #content>
                    <button-icon-right type="cta" label="Verder met vergelijken" />
                  </template>
                </modal-hook>
              </div>
            </template>
          </modal-center>
        </div>
        <span class="subtle-text">
          {{ phoneExtraText }}
        </span>
      </div>

      <!-- Bewaar vergelijking -->
      <transition name="fade" mode="out-in">
        <div v-if="products.length > 0 && !!location" class="panel save-comparison-component desktop"
          @click="$emit('hideFilters')">
          <modal-hook :name="'save-comparison'" class="footer-button">
            <template #content>
              <button class="btn ghost" :disabled="!!savedComparison">
                <span>
                  Bewaar voor later
                </span>
                <Icon icon="x-fa-heart" />
              </button>
            </template>
          </modal-hook>
          <div v-if="savedComparison" class="bubble">
            <icon icon="check-circle-solid" size="sm" />
            <span class="text">{{ signedIn ? 'Deze vergelijking is bewaard' : 'Deze vergelijking is gemaild' }}</span>
          </div>
        </div>
      </transition>

      <div class="panel save-comparison-component">
        <button class="btn ghost" v-if="canShare" @click="social">
          <span>Deel vergelijking</span>
          <Icon icon="x-fa-share" />
        </button>
        <button class="btn ghost" v-else @click="whatsapp">
          <span>Deel vergelijking</span>
          <Icon icon="x-fa-share" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from 'vue-elements/icon/Icon.vue';

import PostalBox from 'vue-elements/comparison-inputs/PostalBox.vue';
import SpeedSlider from './inputs/SpeedSlider.vue';
import TvChannelSelection from './inputs/TvChannelSelection.vue';
import {
  combiProvidersEnergy,
  combiProvidersMobile,
  deliveryTimes,
  productTypes,
  providers,
  contractDurations,
} from '../lib/filterOptions';
import ButtonIconRight from '../../../../abstracts/elements/button/icon-right/button-icon-right.vue';
import ModalHook from '../../../../abstracts/elements/modal/_shared/hook/modalHook.vue';
import ModalCenter from '../../../../abstracts/elements/modal/center/modalCenter.vue';
import LinkIconRight from '../../../../abstracts/elements/link/icon-right/link-icon-right.vue';
import CheckboxInput from '../../../vue-elements/input/CheckboxInput.vue';
import RadioInput from '../../../vue-elements/input/RadioInput.vue';
import FieldLabelWithTooltip from '../../../vue-elements/field/FieldLabelWithTooltip.vue';
import Tooltip from '../../../../abstracts/elements/tooltip/tooltip.vue';
import FieldLabel from '../../../vue-elements/field/FieldLabel.vue';
import SelectInput from '../../../vue-elements/input/SelectInput.vue';

export default {
  components: {
    CheckboxInput,
    RadioInput,
    LinkIconRight,
    ModalHook,
    ButtonIconRight,
    PostalBox,
    TvChannelSelection,
    SpeedSlider,
    Icon,
    ModalCenter,
    FieldLabelWithTooltip,
    FieldLabel,
    Tooltip,
    SelectInput,
  },
  props: [
    'filters',
    'location',
    'quickFilters',
    'show',
    'totalProducts',
    'addressReady',
    'addressDisplayReady',
    'loading',
    'showExtensions',
    'products',
    'savedComparison',
    'signedIn',
  ],
  emits: ['hideFilters', 'postal', 'editAddress', 'filter'],
  data() {
    return {
      localFilters: {},
      tvChannelLabel: 'Geen extra zenders',
      productTypes,
      deliveryTimes,
      providerList: providers,
      combiProvidersEnergy,
      combiProvidersMobile,
      contractDurations,
      internetTypeToggle: false,
      providerToggle: false,
      tvExtraToggle: false,
      shareState: 'default',
      canShare: true,
    };
  },
  computed: {
    dslLabel() {
      return this.maxDsl ? `DSL tot ${this.maxDsl} MBit/s` : 'DSL';
    },
    cableLabel() {
      return this.maxCable ? `Kabel tot ${this.maxCable} MBit/s` : 'Kabel';
    },
    fiberLabel() {
      return this.maxFiber ? `Glasvezel tot ${this.maxFiber} MBit/s` : 'Glasvezel';
    },
    internetTypeText() {
      const text = [];
      if (this.localFilters.dsl) {
        text.push(this.dslLabel);
      }
      if (this.hasCable && this.localFilters.cable) {
        text.push(this.cableLabel);
      }
      if (this.hasFiber && this.localFilters.fiber) {
        text.push(this.fiberLabel);
      }
      return text.length > 0 ? text.join(', ') : 'Geen type geselecteerd';
    },
    shareData() {
      return {
        title: 'Keuze.nl vergelijking',
        text: 'Hoi! Check deze vergelijking op Keuze.nl:',
        url: window.location.href,
      };
    },
    combiProviderText() {
      if (this.localFilters.combiProviders?.length > 0 || this.localFilters.combiProvidersEnergy?.length > 0) {
        const labels = [];
        if (this.localFilters.combiProviders?.length > 0) {
          this.localFilters.combiProviders.forEach((provider) => {
            this.combiProvidersMobile.forEach((providerObject, index, array) => {
              if (providerObject.slug === provider) {
                labels.push(providerObject.label);
              }
            });
          });
        }
        if (this.localFilters.combiProvidersEnergy?.length > 0) {
          this.localFilters.combiProvidersEnergy.forEach((provider) => {
            this.combiProvidersEnergy.forEach((providerObject, index, array) => {
              if (providerObject.slug === provider) {
                labels.push(providerObject.label);
              }
            });
          });
        }
        return labels.join(', ');
      }
      return 'Geen voordeel: kies je provider of leverancier';
    },
    providerText() {
      if (this.localFilters.providers?.length > 0) {
        const labels = [];
        this.localFilters.providers.forEach((provider) => {
          this.providerList.forEach((providerObject, index, array) => {
            if (providerObject.value === provider) {
              labels.push(providerObject.label);
            }
          });
        });
        return labels.join(', ');
      }
      return 'Alle 10 providers tonen';
    },
    tvExtraText() {
      const text = [];
      if (this.localFilters.tvExtraReceiver) text.push('Extra ontvanger');
      if (this.localFilters.tvRecording) text.push('TV opnemen');
      if (this.localFilters.tvRewind) text.push('Live terugkijken');
      if (this.localFilters.tvApp) text.push('Kijken via app');

      return text.length > 0 ? text.join(', ') : 'Geen opties geselecteerd';
    },
    phoneExtraText() {
      const text = [];
      if (this.localFilters.numberRetention) text.push('Nummerbehoud');
      if (this.localFilters.phoneUnlimitedNL) text.push('Onbeperkt bellen Nederland');
      if (this.localFilters.phoneUnlimitedEU) text.push('Onbeperkt bellen EU-nummers');
      if (this.localFilters.phoneUnlimitedWorld) text.push('Wereldwijd onbeperkt bellen');

      return text.length > 0 ? text.join(', ') : 'Geen extra opties voor bellen';
    },
    phoneEnabled() {
      return this.filters.productType === 'ip' || this.filters.productType === 'ipt' || this.filters.productType === 'all';
    },
    tvEnabled() {
      return this.filters.productType === 'it' || this.filters.productType === 'ipt' || this.filters.productType === 'all';
    },
    maxSpeed() {
      if (this.location != null && this.location.data != null && this.location.data.max_speed != null) {
        return this.location.data.max_speed;
      }
      return 1000;
    },
    hasDsl() {
      return this.maxDsl != null || this.location == null || !this.location.data.address_found;
    },
    maxDsl() {
      if (this.location != null && this.location.data.max_speed != null && this.location.data.max_dsl != null) {
        if (this.maxDslBonding > this.location.data.max_dsl) {
          return this.maxDslBonding;
        }
        return this.location.data.max_dsl;
      }
      return null;
    },
    maxDslBonding() {
      if (this.location != null && this.location.data.max_dsl_bonding != null) {
        return this.location.data.max_dsl_bonding;
      }
      return null;
    },
    hasCable() {
      return this.maxCable !== null || this.location == null || !this.location.data.address_found;
    },
    maxCable() {
      if (this.location != null && this.location.data != null && this.location.data.max_speed != null && this.location.data.max_cable != null) {
        return this.location.data.max_cable;
      }
      return null;
    },
    hasFiber() {
      return this.maxFiber !== null || this.location == null || !this.location.data.address_found;
    },
    maxFiber() {
      if (this.location != null && this.location.data != null && this.location.data.max_speed != null && this.location.data.max_fiber != null) {
        return this.location.data.max_fiber;
      }
      return null;
    },
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(filters) {
        this.localFilters = filters;
      },
    },
    localFilters: {
      deep: true,
      handler(localFilters) {
        this.$emit('filter', localFilters);
      },
    },
  },
  mounted() {
    this.localFilters = this.filters;
    if (this.localFilters.providers === null) {
      this.localFilters.providers = [];
    }
    this.canShare = typeof navigator.share !== 'undefined';
  },
  methods: {
    social() {
      this.shareState = 'default';
      try {
        navigator.share(this.shareData)
          .catch(() => {
            this.shareState = 'error';
          });
      } catch (err) {
        this.shareState = 'error';
      }
    },
    whatsapp() {
      const url = window.location.href;
      const encodedUrl = encodeURIComponent(`Hoi! Check deze vergelijking op Keuze.nl: \n ${url}`);
      window.open(`https://wa.me/?text=${encodedUrl}`, '_blank');
    },
    setLabels(channel) {
      this.tvChannelLabel = channel.length > 0 ? channel.join(', ') : 'Geen extra zenders';
    },
  },
};
</script>

<style lang="scss">
@use "assets/scss/all.scss" as *;

.filters {
  color: $text-base;
  z-index: 10;

  .radio-list {
    display: grid;
    grid-gap: 8px;
    margin-bottom: 16px;
  }

  .checkbox-list {
    margin-bottom: 16px;

    .checkbox-input-field:not(:last-child) {
      margin-bottom: 6px;
    }
  }

  .header {
    @include header-24;
    font-weight: 600;
    display: block;
    margin-bottom: 12px;

    &.address {
      font-size: 18px;
    }
  }

  .filter-field {
    margin-bottom: 24px;
  }

  .tooltip.top-right .tooltip-content-container {
    @include breakpoint-down(sm) {
      left: -8px !important; // Negate the padding of the filterbar
    }
  }

  .panel-filter-header {
    @include flex-row-between();
    @include paragraph-16;
    font-weight: 500;

    width: 100%;

    label {
      @include link-icon-right-link-alt();
      cursor: pointer;
    }

    .card-element.default {
      @include breakpoint-up(lg) {
        width: 720px;
      }

      .content {
        width: 100%;
        padding: 0px;

        @include breakpoint-up(md) {
          padding: 20px;
        }

        @include breakpoint-up(lg) {
          padding: 24px;
        }
      }
    }
  }

  .filter-update-toggle {
    display: flex;
    margin-top: 12px;
    cursor: pointer;
    text-decoration: none;

    .toggle {
      @include link-icon-right-link-alt();
    }

    .icon-element {
      margin-left: 12px;
      background: $link-base-default;
    }
  }
}


.filter-modal {
  .card-element {
    @include breakpoint-down(md) {
      padding: 24px 16px 105px;
    }
  }

  .content {
    @include flex-col-start();

    gap: 24px;
    padding: 0;

    @include breakpoint-up(md) {
      padding: 24px;
    }

    >div {
      width: 100%;

      &:not(:last-child) {
        border-bottom: 1px solid $border-base;
        padding-bottom: 24px;
      }
    }
  }

  .modal-container {
    .modal-header {
      @include flex-col-start();
    }

    .modal-footer {
      @include flex-row-between();
    }

    .modal-title {
      @include header-24;
    }

    .modal-intro {
      @include paragraph-17;
    }
  }

  .checkbox-list {
    margin: 0 !important;
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 8px;

    @include breakpoint-up(sm) {
      grid-template-columns: 1fr 1fr;
      row-gap: 8px;
      column-gap: 32px;
    }
  }
}

.subtle-text {
  color: $text-subtle;
}

.innerfilters {

  .consumption-summary {
    margin-bottom: 12px;
  }

  .consumption-item {
    @include flex-row-between;
    @include paragraph-14;

    .value {
      cursor: pointer;
    }

    +.consumption-item {
      margin-top: 8px;
    }

    hr.line {
      height: 1px;
      flex: 1;
      align-items: center;
      justify-content: center;
      margin: 0 12px;
      color: $border-subtle;
    }
  }

  .panel {
    padding: 24px;
    border-bottom: 1px solid $border-subtle;
    border-right: 1px solid $border-subtle;

    &.small {
      padding: 16px 24px;
    }

    @include breakpoint-up(lg) {
      padding: 24px 48px 24px 0;

      &.small {
        padding: 16px 48px 16px 0;
      }

      &:first-of-type {
        padding-top: 0;
      }
    }

    &:last-child {
      border-bottom: 0;
    }
  }



  .field-label>.label {
    margin-bottom: 8px;
    font-weight: 500;
  }

  .speed-advice {
    .button {
      height: 48px;
      display: flex;
      padding: 0 12px;
      border-radius: 16px;
      border: 2px solid $link-base-default;
      margin: 8px 0;

      .icon-element {
        background-color: $link-base-default;
        width: 24px;
        height: 24px;
      }

      &>span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: $link-base-default;
      }
    }
  }

  .label.label-combi {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &>div,
    label {
      display: inline-flex;
    }
  }

  .label-value {
    font-weight: 700;
  }


  .label-with-tooltip {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    position: relative;

    .field-label {
      margin-bottom: 0;
    }
  }

  .field+.field {
    margin-top: 12px;
  }
}
</style>
